import { ChipsContainer } from 'app/ComponentLibrary/Filter/ChipsContainer';
import React, { createRef } from 'react';
import { useState } from 'react';
import { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { selectFilters, selectGridState } from '@AMIEWEB/Common/Grid/GridStateManagement/GridState.selectors';
import { instanceOfISelection } from 'app/ComponentLibrary/Filter/CustomSelect';
import { generateTaskChips, returnTaskFilterBody, TaskSearchFilterName } from './TaskFilters/TaskFilterUtilitis';
import { TaskCategory } from 'app/models/Tasks/Tasks';
import { gridStateActions } from '@AMIEWEB/Common/Grid/GridStateManagement/GridState.redux';

export const TaskResultsChips = props => {
  const dispatch = useDispatch();
  const [chips, setChips] = useState({});
  const hiddenSubmitButton = createRef<HTMLButtonElement>();
  const { setValue, getValues } = useFormContext();
  const filterObject = useSelector(selectFilters);
  const { filterAttributes } = useSelector(selectGridState);
  const [deleteMultipleChips, setDeleteMultipleChips] = React.useState<boolean>(false);

  const handleChipDelete = (field, chip) => {
    const chosenValue = getValues(field);

    if (chosenValue && chosenValue.length > 0 && Array.isArray(chosenValue)) {
      const newValues = [...chosenValue];
      newValues.splice(
        newValues.findIndex(opt => (instanceOfISelection(chip) ? opt.value : opt) === chip.value),
        1,
      );
      setValue(field, newValues);
    } else {
      if (field === 'dueDate') {
        setValue(field, null);
      } else {
        setValue(field, []);
      }
    }

    const newFilters = returnTaskFilterBody(
      field,
      field === 'dueDate' ? chip.label : chip.value,
      filterAttributes?.selectedChipFilters,
      true,
    );
    // remove task names if rfo is not in categories
    if (
      field === TaskSearchFilterName.taskCategory &&
      newFilters.taskCategories?.length > 0 &&
      !newFilters.taskCategories?.find(f => f === TaskCategory.MISSINGRFOREQS) &&
      newFilters.taskName?.length > 0
    ) {
      newFilters.taskName = [];
      setValue(TaskSearchFilterName.taskName, []);
    }
    dispatch(gridStateActions.setSelectedChips(newFilters));
    props.onApplyFilter(getValues());
  };

  /** Restricted to call onApplyfilter directly -
   * observes not to remove existing filter and chips */

  useEffect(() => {
    setChips(
      filterObject?.filters
        ? generateTaskChips(filterObject?.filters, props.hideDelete, filterObject?.selectedChipFilters)
        : {},
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filterObject?.filters]);

  useEffect(() => {
    if (deleteMultipleChips) {
      const chip = { label: filterObject?.filters.radius, enabledelete: true, value: filterObject?.filters.radius };
      handleChipDelete('radius', chip);
      setDeleteMultipleChips(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [deleteMultipleChips]);

  return (
    <>
      <ChipsContainer
        chips={chips}
        onDelete={(field, chip, index) => handleChipDelete(field, chip)}
        onClick={(field, chip, index) => {}}
      />
      <button ref={hiddenSubmitButton} style={{ display: 'none' }} type="submit" />
    </>
  );
};
